<template>
  <div>
    <p style="position: absolute;left: -999999px;">{{ changeInfoTemp }}</p>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-orders'>{{translations('navbar.sale_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-orders'>{{translations('order.archive_order')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('order.order_detail')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div v-show="Number(ordersInfo.outsourcing_type) < 2 || Number(ordersInfo.outsourcing_type) === 3" class='form mb-3'><!-- 0:未登録, 1:通常販売, 2:委託販売, 3:任意 -->
            <v-row>
              <v-col class="d-flex align-center" cols="6" :sm="setValueSmOrder">
                <template v-if="!isNeedApprove || isApproved">
                  <button class='btn btn-primary'
                    v-if="ordersInfo.division_type !== 'B'"
                    :disabled="((Number(ordersInfo.order_status) === 2) || (Number(ordersInfo.order_status) === 12) || !ordersInfo.destination_id || disableButtonShip)"
                    data-toggle="modal"
                    data-target="#SingleOrdersModal"
                    @click="buttontype=1">{{translations('order.shipping_process')}}</button>

                  <button class='btn btn-primary'
                    v-else
                    :disabled="((Number(ordersInfo.order_status) === 5) || disableButtonShip)"
                    data-toggle="modal"
                    data-target="#SingleOrdersModal"
                    @click="buttontype=1">{{translations('order.shipping_process')}}</button>
                </template>
                <template v-else-if="isNeedApprove && isNotRequestApprove" class='mb-4'>
                  <button class='btn btn-primary' @click="requestApprove">{{translations('order.approval_app')}}</button>
                </template>
              </v-col>
              <v-col v-if="Number(ordersInfo.order_status) === 1" class="d-flex align-center" cols="6" :sm="setValueSmReserve" >
                <template>
                  <button :disabled="tempInfo.division_type === 'B'" class='btn btn-info' @click="moveToReserve">{{ translations('reserve.reserve_process') }}</button>
                </template>
              </v-col>
              <v-col class="d-flex align-center" cols="6" :sm="setValueSmReturn">
                <button :disabled="!beforeId" class='btn btn-primary' @click="returnOn">{{translations('order.return')}}</button>
              </v-col>
              <v-col class="d-flex align-center" cols="6" sm="2">
                <button :disabled="!afterId" class='btn btn-primary' @click="moveOn">{{translations('order.move_on')}}</button>
              </v-col>
            </v-row>
            <div v-if="isNeedApprove && isNotRequestApprove" class='mb-4'>
              <small class="text-danger">{{translations('order.information_message')}}</small>
            </div>
            <div v-if="isNeedApprove && !isNotRequestApprove && !isApproved" style="">
              <h6 class='mb-3 approval text-danger'>{{translations('order.information_message')}}</h6>
              <table class='table table-sm table-borderless table-information'>
                <tbody>
                  <tr v-for="(user, i) in approveUsers" :key="i">
                    <th>{{ user.name }}</th>
                    <td v-if="isUserApproved(user)"><span class="text-primary padding-left-8">{{translations('order.approved')}}</span></td>
                    <td v-else-if="isApproveRole(user)"><button type='button' class='btn btn-primary btn-sm' @click="approve(user)">{{translations('order.approve')}}</button></td>
                    <td v-else><span class="text-danger padding-left-8">{{translations('order.unapproved')}}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-show="Number(ordersInfo.outsourcing_type) === 2 || Number(ordersInfo.outsourcing_type) === 3" class='form-inline mb-3'><!-- 0:未登録, 1:通常販売, 2:委託販売, 3:任意 -->
            <div class='form-group'><!-- 1:未出荷, 2:出荷済, 3:一部出荷 -->
              <button class='btn btn btn-info mr-2' :disabled="Number(ordersInfo.order_status) === 2 || !ordersInfo.destination_id" data-toggle="modal" data-target="#SingleOrdersModal" @click="buttontype=2">{{translations('order.delivery_processing')}}</button>
              <button class='btn btn btn-info' data-toggle="modal" data-target="#SingleConsignmentOrdersModal" >{{translations('order.register_sales')}}</button><!-- FREE TO SALES -->
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('order.order_status')}}</th>
                <td>
                  <span class="badge" :class="getStatusClass(ordersInfo.order_status, ordersInfo.division_type)">
                    {{ getStatusLabel(ordersInfo.order_status, ordersInfo.division_type) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.order_date')}}</th>
                <td v-show="(Number(ordersInfo.order_status) === 1)">
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '--------------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.order_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.ordered_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('ordered_at', tempInfo.ordered_at, 'info01')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== 1)">{{$invoiceTools.formatDateAt(ordersInfo.ordered_at)}}</td>
              </tr>
              <tr>
                <th>{{translations('order.division')}}</th>
                <td>
                  <button
                    :disabled="(Number(ordersInfo.order_status) !== 1)"
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{  divisionRenderText(ordersInfo.division_type) }} </button>
                  <!-- <p v-else>{{ divisionRenderText('D') }}</p> -->

                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.division')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.division_type_select">
                        <option value="null">-----------</option>
                        <option
                          :disabled="type.value === 'D'"
                          v-for="type in DivisionTypes"
                          :key="type.value"
                          :value="type.value"
                        >
                          {{type.label}}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('division_type', tempInfo.division_type_select, 'info02')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <!-- <td v-show="(Number(ordersInfo.order_status) !== 1)">{{ordersInfo.name}}</td> -->
              </tr>
              <tr>
                <th>{{translations('order.order_number')}}</th>
                <td>{{ordersInfo.order_number}}</td>
              </tr>
              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.bill_to')}}</th>
                <td v-show="(!ordersInfo.estimate_id) && (Number(ordersInfo.order_status) === 1)">
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ ordersInfo.client && ordersInfo.client.name ? ordersInfo.client.name : '--------------' }}</button>
                  <div v-if="billings" ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.bill_to')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="billings" label="name" value="id" v-model="tempInfo.client"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('client_id', tempInfo.client, 'info04')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="ordersInfo.estimate_id || (Number(ordersInfo.order_status) !== 1)">{{ ordersInfo.client_name }}</td>
              </tr>

              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.bill_to')}}</th>
                <td>
                  <button
                    :disabled="(Number(ordersInfo.order_status) !== 1)"
                    ref='info005'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info005'
                    data-placement='right'
                  >{{ ordersInfo.warehouse_address_from ? ordersInfo.warehouse_address_from : '-----------' }}</button>

                  <div id='popover-info005' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.bill_to')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <div class="warehouse_style">
                      <v-select
                        :options="warehouses"
                        value="id"
                        v-model="tempInfo.warehouse_id_from"
                        label="name"
                      >
                        <template slot="selected-option" slot-scope="option">
                          {{ option.name }}
                        </template>
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                    </v-select>
                  </div>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('warehouse_id_from', tempInfo.warehouse_id_from, 'info005')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.destination_name')}}</th>
                <td>
                  <button
                    :disabled="(Number(ordersInfo.order_status) !== 1)"
                    ref='info004'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info004'
                    data-placement='right'
                  >{{ ordersInfo.warehouse_address ? ordersInfo.warehouse_address : '-----------' }}</button>

                  <div id='popover-info004' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.destination_name')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <div class="warehouse_style">
                      <v-select
                        :options="warehouses"
                        value="id"
                        v-model="tempInfo.warehouse_id"
                        label="name"
                      >
                        <template slot="selected-option" slot-scope="option">
                          {{ option.name }}
                        </template>
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                    </v-select>
                  </div>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('warehouse_id', tempInfo.warehouse_id, 'info004')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.destination_name')}}</th>
                <td v-if="Number(ordersInfo.order_status) === 1"><!-- 未出荷 -->
                    <button ref="info05" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info05' data-placement='right'>{{ ordersInfo.destination_name || '--------------' }}</button>
                    <div ref="popover-info05" id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.destination_name')}}</div>
                        <div class='popover-body popover-content'>
                          <v-select :options="destinations" label="name" value="id" v-model="tempInfo.destination"></v-select>
                        </div>
                        <div class='popover-footer'>
                        <button type='submit'  v-on:click="updateField('destination_id', tempInfo.destination.id, 'info05')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                        </div>
                    </div>
                </td>
                <td v-else>{{ ordersInfo.destination_name }}</td>
              </tr>
              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.contact_person')}}</th>
                <td v-show="!(Number(ordersInfo.order_status) !== 1)">
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ ordersInfo.end_user || '--------------' }}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.contact_person')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.end_user" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('end_user', tempInfo.end_user, 'info06')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== 1)">{{ordersInfo.end_user}}</td>
              </tr>
              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.contact_person')}}</th>
                <td>
                  <button
                    ref='info006'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info006'
                    data-placement='right'
                  >
                  {{ ordersInfo.users_in_charge ? ordersInfo.users_in_charge['user_name'] : '-----------' }}
                  </button>
                  <div id='popover-info006' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.contact_person')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="usersList" label="user_name" value="id" v-model="tempInfo.users_in_charge"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('users_in_charge', tempInfo.users_in_charge, 'info006')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.slip_number_dedicated_code')}}</th>
                <td>
                  <div class="d-flex">
                    <input
                      v-model="slipNumber"
                      type="text"
                      class="form-control form-control-sm mr-1"/>
                    <input
                      v-model="cdItem"
                      type="text"
                      class="form-control form-control-sm w-75"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.temporary_direct_transmission')}}</th>
                <td>
                  <input v-model="isTempShipping" type="checkbox" @change="changeTempShipping">
                </td>
              </tr>
              <tr>
                <th>{{translations('order.company_name')}}</th>
                <td>
                  <input
                  v-model="tempInfo.company_name_temp"
                  type="text"
                  class="form-control form-control-sm"
                  :class="{'text-transparent': !isTempShipping}"
                  :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.place_delivery')}}</th>
                <td>
                  <textarea
                  v-model="tempInfo.destination_name_temp"
                  type=""
                  class="form-control form-control-sm min-height-120"
                  :class="{'text-transparent': !isTempShipping}"
                  :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.supplier')}}</th>
                <td>
                  <textarea
                    v-model="tempInfo.suppliers_temp"
                    type="text"
                    class="form-control form-control-sm min-height-120"
                    :class="{'text-transparent': !isTempShipping}"
                    :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.remarks')}}</th>
                <td>
                  <input
                    v-model="tempInfo.note_temp"
                    type="text"
                    class="form-control form-control-sm"
                    :class="{'text-transparent': !isTempShipping}"
                    :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.amount')}}</th>
                <td>
                  <input
                    v-if="isTempShipping"
                    v-model="tempInfo.remove_price_temp"
                    type="checkbox"/>
                  <input
                    v-else
                    type="checkbox"
                    disabled />
                </td>
              </tr>
              <tr>
                <th>{{translations('order.remarks')}}</th>
                <td v-show="!(Number(ordersInfo.order_status) !== 1)">
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ ordersInfo.memo || '--------------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== 1)">{{ordersInfo.memo}}</td>
              </tr>
              <tr>
                <th>{{translations('order.internal_memo')}}</th>
                <td v-show="!(Number(ordersInfo.order_status) !== 1)">
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0 btn-memo-internal'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                    style="white-space: pre-line"
                  >{{ ordersInfo.note || '--------------' }}
                  </button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.internal_memo')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea type='text' v-model.trim="tempInfo.note" class='form-control' maxlength="300" />
                    </div>
                    <div class='popover-footer d-flex justify-content-between'>
                      <button type="button" class="btn btn-sm btn-secondary" @click="closeModal('info08')">{{translations('common.close')}}</button>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('note', tempInfo.note, 'info08')">{{translations('common.keep')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== 1)">{{ordersInfo.note}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{ordersInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{ordersInfo.updated_at}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <h5>Files</h5>
          <div class="card" :class="(poFile == null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-info d-flex justify-content-between"><a @click="openPdf()">{{translations('order.purchase_order')}}<i class="fas fa-external-link-alt"></i></a><button type="button" class="btn btn-link p-0 mr-1" @click="poFile = null"><i class="far fa-times-circle"></i></button></li>
            </ul>
          </div>
          <div class="card" :class="(poFile == null) ? '' : 'hidden'">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#NewOrdersFileModal">{{translations('order.purchase_order')}}<i class="fas fa-paperclip"></i></button></li>
            </ul>
          </div>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteOrders()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <input :disabled="(Number(ordersInfo.order_status) !== 1)" :checked="allChecked" type="checkbox" @change="onChangeCheckedAll"/>
                  </th>
                  <th>{{translations('order.commodity_condition')}}</th>
                  <th>{{translations('order.line_number')}}</th>
                  <th>{{translations('order.jan_code')}}</th>
                  <th>{{translations('order.model')}}</th>
                  <th>{{translations('order.product_abbreviation_name')}}</th>
                  <th>{{translations('order.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('order.quantity')}}</th>
                  <th>{{translations('order.unit_price')}}</th>
                  <th>{{translations('order.product_cost')}}</th>
                  <th>{{translations('order.client_order_number')}}</th>
                  <th>{{translations('order.summary')}}</th>
                  <th>{{translations('order.product_internal_memo')}}</th>
                  <th>{{translations('order.unit_price_total')}}</th>
                  <th>{{translations('order.total_cost')}}</th>
                  <th>{{translations('order.total_profit')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in ordersDetails">
                  <tr :key="i">
                    <td v-if ="detail.reserved == 0 || !detail.reserved">
                      <button v-if="(Number(ordersInfo.order_status) === 1) || (statusId === 11 && detail.minus)" tabindex="-1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td v-if ="detail.reserved == 0 || !detail.reserved">
                      <input v-if="(Number(ordersInfo.order_status) === 1)" for="checkBox" type="checkbox" :checked="detail.check" :value="detail.id" @change="onChangeInputChecked"/>
                    </td>
                    <td v-if ="detail.reserved == 1" colspan="2">
                      <span class="badge badge-info">
                        {{ translations('order.reserved') }}
                      </span>
                    </td>
                    <td v-if ="detail.reserved == 2" colspan="2">
                      <span class="badge badge-danger">
                        {{ translations('order.status_shipped') }}
                      </span>
                    </td>
                    <td v-if="Number(ordersInfo.order_status) === 1">
                      <select
                        :disabled="detail.reserved == 1"
                        v-model="detail.selectedType"
                        v-on:change="updateSelectedType($event, i)"
                        v-validate="'required'"
                        data-vv-name="type_id"
                        data-vv-as="商品状態"
                        class="custom-select"
                        required
                        style="width: 125px">
                        <option :value="0">{{ translations('order.good') }}</option>
                        <option :value="1">{{ translations('order.bad') }}</option>
                        <option :value="2">{{ translations('order.outlet') }}</option>
                      </select>
                    </td>
                    <td v-else>{{ Number(detail.is_outlet) ? translations('order.outlet') : Number(detail.is_bad) ? translations('order.bad') : translations('order.good') }}</td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.type_number }}</td>
                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.omission_name" :title="detail.omission_name" :disabled="detail.reserved == 1"></td>
                    <td v-if="Number(ordersInfo.order_status) === 1">
                      <select
                        :disabled="detail.reserved == 1"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangeUnitPrice(detail)">
                        <option value="1">{{translations('order.taxable_item')}}</option>
                        <option value="2">{{translations('order.not_applicable')}}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td v-else>{{ Number(detail.taxclass_id) === 1 ? translations('order.taxable_item') : translations('order.not_applicable') }}</td>
                    <td style="min-width:80px;"><input :readonly="(Number(ordersInfo.order_status) !== 1)" type="text" @input="numbers(i,'quantity')" class="form-control form-control-sm" style="width:4em;" v-on:keyup="quantityKeyUp($event,detail)" v-model="detail.quantity" :disabled="detail.reserved == 1"/></td>
                    <template v-if="Number(ordersInfo.order_status) === 1">
                      <td style="min-width:80px;">
                        <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                          <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @change="onChangeUnitPrice(detail)" :disabled="detail.reserved == 1"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                        </div>
                        <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                          <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" @change="onChangeUnitPrice(detail)" :disabled="detail.reserved == 1"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                        </div>
                      </td>
                    </template>
                    <template v-else>
                      <td style="min-width:80px;">
                        <div v-if="!taxIncluded">{{ Number(detail.unit_price).toLocaleString() }}</div>
                        <div v-else>{{ Number(detail.unit_price_inctax).toLocaleString() }}</div>
                      </td>
                    </template>

                    <td class="right"><input :readonly="Number(ordersInfo.order_status) !== 1" type="text" @input="numbers(i,'row_price')" class="form-control form-control-sm" style="width:6em;" v-model="detail.row_price" :disabled="detail.reserved == 1"/></td>
                    <td class="right"><input :readonly="(Number(ordersInfo.order_status) !== 1) && !isCostco" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.client_order_number" :disabled="detail.reserved == 1"/></td>
                    <td class="right"><input :readonly="(Number(ordersInfo.order_status) !== 1)" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks" :disabled="detail.reserved == 1"/></td>
                    <td class="right">
                      <textarea
                        :readonly="Number(ordersInfo.order_status) !== 1"
                        class="form-control form-control-sm"
                        v-model="detail.internal_memo"
                        :rows="calculateRows(detail.internal_memo)"
                        :style="{minHeight: '28px'}"
                        :disabled="detail.reserved == 1"
                      ></textarea>
                    </td>

                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button :disabled="(Number(ordersInfo.order_status) !== 1)"
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#OrdersDetailsModal'
                    >
                      <i></i>
                    </button>
                  </td>
                  <td colspan="13"></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary mr-3' @click="updateOrders()">{{translations('common.update')}}</button>
            </div>
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" href="javascript:;" @click="openDeliverySlip()">{{translations('order.delivery_slip_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
<!--            <div v-show="((ordersInfo.division_type === 'B' ? Number(ordersInfo.order_status) !== 5 : Number(ordersInfo.order_status) !== 2))  && !isCostco">-->
<!--              <a class="btn btn-link btn-sm decoration-underline disabled" href="#" >{{translations('order.slip_output')}}<i class="fas fa-external-link-alt"></i></a>-->
<!--            </div>-->
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
            <div v-show="Number(outsourcingType) === 2 && Number(ordersInfo.order_status) === 2"><!-- order_status 1:未出荷, 2:出荷済, 3:一部出荷 -->
              <a class="btn btn-link btn-sm decoration-underline" href="#" @click="openConsignmentSlip()">{{translations('order.consignment_slip_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" href="javascript:;" @click="printNebaSlip">{{translations('order.slip_printing')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
<!--            <div v-show="((ordersInfo.division_type === 'B' ? Number(ordersInfo.order_status) !== 5 : Number(ordersInfo.order_status) !== 2))  && !isCostco">-->
<!--              <a class="btn btn-link btn-sm decoration-underline disabled" href="#" >{{translations('order.slip_printing')}}<i class="fas fa-external-link-alt"></i></a>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <OrdersDetailsModal :details="ordersDetails" :ordersInfo="ordersInfo" :clients_id="tempInfo.client_id" :tax="{taxIncluded:taxIncluded, taxRate:taxRate}"/><!-- VAT -->

    <SingleOrdersModal  :warehouseRedFlag="warehouses" :ordersInfo="ordersInfo" :orderID="ordersID" :buttonType="buttontype" />
    <SingleConsignmentOrdersModal :orderID="ordersID" :outsourcing-type="outsourcingType"/>
    <NewOrdersFileModal :poFile="poFile"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import OrdersDetailsModal from '@/components/OrdersDetailsModal'
import SingleOrdersModal from '@/components/SingleOrdersModal'
import SingleConsignmentOrdersModal from '@/components/SingleConsignmentOrdersModal'
import NewOrdersFileModal from '@/components/NewOrdersFileModal'
import { CONDITIONS_INVENTORY, DivisionType, OrderStatus } from '../constants'
import _ from 'lodash'
import { mapState } from 'vuex'

const UPDATE_TYPE_NORMAL = 0
const UPDATE_TYPE_INFORMATION = 1
const UPDATE_TYPE_REQUEST_APPROVE = 2
const UPDATE_TYPE_APPROVE = 3

const UNIQ_ADDRESS =
  `株式会社ユニーク
  〒277-0005
  千葉県柏市柏6-4-24 柏ビルディング2A
  TEL 04-7128-6556 FAX 04-7128-6557`

export default {
  name: 'SingleOrders',
  props: {},
  components: {
    VueElementLoading,
    OrdersDetailsModal,
    SingleOrdersModal,
    SingleConsignmentOrdersModal,
    NewOrdersFileModal
  },

  data () {
    return {
      disableButtonShip: false,
      changeInfoTemp: 1,
      outsourcingType: 0,
      buttontype: 0,
      taxRate: 0, // VAT
      taxIncluded: false, // VAT
      department: '',
      ordersID: 0,
      statusId: 0,
      destinations: [],
      ordersInfo: {},
      ordersDetails: [],
      tempInfo: {},
      slipNumber: '',
      cdItem: '',
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      isLoading: true,
      isTempShipping: false,
      isUpdateContact: false,
      poFile: null,
      deliveryFile: null,
      consignmentFile: null,
      beforeId: null,
      afterId: null,
      objectURLs: [],
      DivisionTypes: [],
      warehouses: [],
      usersList: [],
      loadDivisionType: null,
      selectedType: {},
      inputRows: 1,
      allChecked: false,
      isCheckDisable: true
    }
  },

  watch: {
    ordersDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })

        this.ordersDetails = v
        this.ordersDetails.forEach(detail => {
          if ((Number(detail.is_bad) === 1 || detail.is_bad === true) && (Number(detail.is_outlet) === 0 || detail.is_outlet === false)) {
            detail.selectedType = CONDITIONS_INVENTORY.bad.value
          } else if ((Number(detail.is_outlet) === 1 || detail.is_outlet === true) && (Number(detail.is_bad) === 0 || detail.is_bad === false)) {
            detail.selectedType = CONDITIONS_INVENTORY.outlet.value
          } else {
            detail.selectedType = CONDITIONS_INVENTORY.good.value
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    },
    'tempInfo.client_id': {
      handler: function (v, oldV) {
        const cname = this.getInfoClient(v)
        this.ordersInfo.client.name = cname
        if (oldV && this.tempInfo.division_type_select !== 'B') {
          this.ordersInfo.destination_name = ''
          this.ordersInfo.destination_id = '0'
          this.getEmployeeByCompany()
        }
        this.listDestinations()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.orders_id) {
      this.$router.replace('archive-orders')
    }
    this.listWarehouses()
    this.listUsers()
    this.isLoading = true
    this.ordersID = Number(this.$route.query.orders_id)
    this.statusId = Number(this.$route.query.status_id)
    this.$store.dispatch('Master/checkBillTo')
    DivisionType.forEach((divisionType) => {
      if (divisionType.value !== 'E') {
        this.DivisionTypes.push(divisionType)
      }
    })

    Promise.all([
      this.getOrders(),
      this.getPoFile()
    ]).then(() => {
      this.popoverButtons()
      if (this.isUpdateContact) {
        this.updateField('end_user', this.tempInfo.end_user, 'info06')
        this.isUpdateContact = false
      }
    }).finally(() => {
      this.isLoading = false
    })
  },
  beforeDestroy () {
    this.objectURLs.forEach(objectURL => {
      URL.revokeObjectURL(objectURL)
    })
  },

  computed: {
    ...mapState(['currentLanguage']),
    billings () {
      return this.$store.getters['Master/getBillTo']
    },
    isApproved () {
      return Number(this.ordersInfo.approval_status) === 2
    },
    isNotRequestApprove () {
      return Number(this.ordersInfo.approval_status) === 0
    },
    isNeedApprove () {
      return !!this.ordersInfo.credit_quantity && (this.grandTotalUnitPrice >= this.ordersInfo.credit_quantity && this.grandTotalUnitPrice > 0) // BUGFIX 合計０の時は認証チェック不要
      // return false // STAGING DEBUG
    },
    approveUsers () {
      return this.ordersInfo.need_approvers ? JSON.parse(this.ordersInfo.need_approvers) : []
    },
    isPrintNeba () {
      return Number(this.outsourcingType) !== 2 && (Number(this.ordersInfo.order_status) === 2 || Number(this.ordersInfo.order_status) === 5)
    },
    isCostco () {
      return this.department === 'コストコ'
    },
    isShowPrintNeba () {
      if (this.isCostco) return true
      if (this.isPrintNeba && (!this.isNeedApprove || this.isApproved)) return true
      return false
    },
    setValueSmOrder () {
      if (this.currentLanguage === 'en' && Number(this.ordersInfo.order_status) === OrderStatus.NOT_SHIPPED) {
        return 5
      } else if (this.currentLanguage !== 'en' && Number(this.ordersInfo.order_status) === OrderStatus.NOT_SHIPPED) {
        return 3
      } else {
        return 6
      }
    },
    setValueSmReserve () {
      if (this.currentLanguage === 'en' && Number(this.ordersInfo.order_status) === OrderStatus.NOT_SHIPPED) {
        return 6
      } else {
        return 4
      }
    },
    setValueSmReturn () {
      if (this.currentLanguage === 'en') {
        return 3
      } else {
        return 2
      }
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, detail) {
      let { value } = event.target
      value = value.replace(/\D/g, '')
      if (value && value <= 0) value = 1
      detail.quantity = value
      event.target.value = detail.quantity
    },
    async listUsers () {
      try {
        let { data } = await this.$http.post(this.$api_url.account_user_list)
        if (data.status === true) {
          this.usersList = data.list
        } else {
          this.usersList = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    async listWarehouses () {
      try {
        let { data } = await this.$http.post(`${this.$api_url.warehouse_list}?typeB=true`)
        if (data.status === true) {
          this.warehouses = data.list
        } else {
          this.warehouses = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    divisionRenderText (divisonType) {
      for (let index = 0; index < DivisionType.length; index++) {
        const element = DivisionType[index]
        if (element.value === divisonType) {
          return element.label
        }
      }
      return '-----------'
    },
    numbers (index, target) {
      this.ordersDetails[index][target] = this.ordersDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { clients_id: this.tempInfo.client_id }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'SingleOrders:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SingleOrders:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()}`
      } else {
        return `${Number(valIncTax).toLocaleString()}`
      }
    },
    toTaxFormat (data, key) {
      if (this.taxIncluded) {
        key = key + '_inctax'
      }
      const price = data[key] || 0
      return Number(price).toLocaleString()
    },

    prepareDetails (data, hasCost = false) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = data.quantity * data.unit_price_inctax
        data.total_profit_inctax = data.total_unit_price_inctax - data.total_cost_inctax
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.ordersDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
        this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    getOrders () {
      return this.$http.post(this.$api_url.orders_detail, { orders_id: this.ordersID, reserve: false, status_id: this.statusId }).then(response => {
        let result = response.data
        if (result.status === true) {
          this.ordersInfo = result.information
          let details = result.details.map(function (elem) {
            elem.check = false
            return elem
          })
          this.ordersDetails = details
          this.tempInfo = result.information
          this.tempInfo.client = {
            id: this.tempInfo.client_id,
            name: this.tempInfo.client_name
          }
          this.tempInfo.division_type_select = result.information.division_type
          this.tempInfo.destination = {
            id: this.tempInfo.destination_id,
            name: this.tempInfo.destination_name
          }
          this.cdItem = this.tempInfo.cd_item
          this.slipNumber = this.tempInfo.slip_number
          this.tempInfo.ordered_at = this.$invoiceTools.formatDateAt(result.information.ordered_at, 1)
          this.isTempShipping = Boolean(Number(this.tempInfo.is_send_temp))
          if (this.isTempShipping) this.changeTempShipping()
          this.taxRate = result.information.tax_rate
          this.taxIncluded = result.information.tax_included
          this.outsourcingType = result.information.outsourcing_type
          if (result.information.division_type === 'B') {
            let indexWareHouse = _.findIndex(this.warehouses, function (o) { return o.id === parseInt(result.information.warehouse_id) })
            this.tempInfo.warehouse_id = this.warehouses[indexWareHouse]
            this.ordersInfo.warehouse_address = this.warehouses[indexWareHouse].name

            let indexWareHouseFrom = _.findIndex(this.warehouses, function (o) { return o.id === parseInt(result.information.warehouse_id_from) })
            this.tempInfo.warehouse_id_from = this.warehouses[indexWareHouseFrom]
            this.ordersInfo.warehouse_address_from = this.warehouses[indexWareHouseFrom].name

            let indexUserCharge = _.findIndex(this.usersList, function (o) { return parseInt(o.id) === parseInt(result.information.users_in_charge) })
            this.tempInfo.users_in_charge = this.usersList[indexUserCharge]
            this.ordersInfo.users_in_charge = this.usersList[indexUserCharge]
          }
          this.loadDivisionType = result.information.division_type

          // 前後のレコードを取得する
          if (result.before_id.length) {
            this.beforeId = result.before_id[0].id
          }
          if (result.after_id.length) {
            this.afterId = result.after_id[0].id
          }
          if (!this.tempInfo.end_user && this.tempInfo.end_user !== '') {
            this.getEmployeeByCompany()
          } else {
            this.isUpdateContact = true
          }
          return Promise.resolve()
        } else {
          this.$toastr.error(result.message)
          this.$router.push('/archive-orders')
        }
      }).catch(error => {
        console.log('SingleOrders:getOrders:catch(error): ', error)
        return Promise.reject(new Error(this.translations('order.notice_failed')))
      })
    },

    // 発注書
    getPoFile () {
      return this.$http.post(this.$api_url.orders_po_file, { orders_id: this.ordersID }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.poFile = result.po_file || null
          return Promise.resolve()
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(error => {
        console.log('SingleOrders:getPoFile:catch(error): ', error)
        return Promise.reject(new Error(this.translations('order.notice_failed')))
      })
    },

    // 発注書
    openPdf () {
      if (this.poFile != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.poFile.replace('data:application/pdf;base64,', ''))
        const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
        const pdfFileURL = URL.createObjectURL(pdfFile)
        window.open(pdfFileURL)
      }
    },

    // Print Neba Form
    printNebaSlip () {
      this.isLoading = true
      const params = this.isTempShipping ? {
        orders_id: [this.ordersID],
        is_send_temp: Number(this.isTempShipping),
        remove_price_temp: this.tempInfo.remove_price_temp,
        destination_name_temp: this.tempInfo.destination_name_temp,
        company_name_temp: this.tempInfo.company_name_temp,
        suppliers_temp: this.tempInfo.suppliers_temp,
        note_temp: this.tempInfo.note_temp,
        slip_number: this.slipNumber,
        cd_item: this.cdItem
      } : {
        orders_id: [this.ordersID],
        is_send_temp: Number(this.isTempShipping),
        slip_number: this.slipNumber,
        cd_item: this.cdItem
      }
      this.$http.post(this.$api_url.orders_neba, params).then(response => {
        const result = response.data
        if (result.status || result.slip) {
          const arrBuff = this.__b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
          const deliveryFileURL = URL.createObjectURL(deliveryFile)
          window.open(deliveryFileURL)
          this.objectURLs.push(deliveryFileURL)
        } else {
          this.$toastr.error(result.message)
        }
      }).catch(() => {
        this.$toastr.error(this.translations('order.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    // 納品伝票
    openDeliverySlip () {
      this.isLoading = true
      const params = this.isTempShipping ? {
        orders_id: this.ordersID,
        is_send_temp: Number(this.isTempShipping),
        remove_price_temp: this.tempInfo.remove_price_temp,
        destination_name_temp: this.tempInfo.destination_name_temp,
        company_name_temp: this.tempInfo.company_name_temp,
        suppliers_temp: this.tempInfo.suppliers_temp,
        note_temp: this.tempInfo.note_temp,
        slip_number: this.slipNumber,
        cd_item: this.cdItem
      } : {
        orders_id: this.ordersID,
        is_send_temp: Number(this.isTempShipping),
        slip_number: this.slipNumber,
        cd_item: this.cdItem
      }
      this.$http.post(this.$api_url.orders_delivery_slip, params).then(response => {
        const result = response.data
        if (result.status === true || result.slip) {
          const arrBuff = this.__b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
          const deliveryFileURL = URL.createObjectURL(deliveryFile)
          window.open(deliveryFileURL)
        } else {
          console.log('SingleOrders:openDeliverySlip:status=false: ', result.message)
        }
      }).catch(error => {
        console.log('SingleOrders:openDeliverySlip:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    // 委託納品伝票
    openConsignmentSlip () {
      this.isLoading = true
      return this.$http.post(this.$api_url.orders_consignment_slip, { orders_id: this.ordersID }).then(response => {
        const result = response.data
        if (result.status === true && result.slip) {
          let arrBuff = this.__b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const consignmentFile = new Blob([arrBuff], { type: 'application/pdf' })
          const consignmentFileURL = URL.createObjectURL(consignmentFile)
          window.open(consignmentFileURL)
        } else {
          console.log('SingleOrders:openConsignmentSlip:status=false: ', result.message)
        }
      }).catch(error => {
        console.log('SingleOrders:openConsignmentSlip:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },
    getInfoClient (id) {
      const infoClient = this.billings.find(bill => bill.id === parseInt(id))
      if (infoClient) {
        this.taxIncluded = Number(infoClient.taxstatus) === 2
        this.department = infoClient.department
        return infoClient.name
      }
      return ''
    },
    getDestinationName (id) {
      let vname = ''
      this.destinations.forEach(function (v) {
        if (v.id === parseInt(id)) {
          vname = v.name
          return true
        }
      })
      return vname
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'ordered_at') {
          $this.$refs[ref].innerText = '--------------'
        } else {
          $this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'client_id') {
        this.billings.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.outsourcingType = v.outsourcingstatus // 委託先向けのUI切替 (0:非該当, 1:該当, 2:任意)
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destination_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'ordered_at') {
        const x = /-/gi
        $this.$refs[ref].innerText = value.replace(x, '/')
        val = value.replace(x, '/')
      } else if (field === 'division_type') {
        this.ordersInfo[field] = value
        $this.$refs[ref].innerText = this.divisionRenderText(value)
        val = value
        this.disableButtonShip = true
        console.log(this.loadDivisionType)
        if (this.loadDivisionType === value) {
          this.disableButtonShip = false
        }
        this.ordersInfo['warehouse_id'] = null
      } else if (field === 'warehouse_id') {
        this.disableButtonShip = true
        this.ordersInfo['warehouse_address'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'warehouse_id_from') {
        this.disableButtonShip = true
        this.ordersInfo['warehouse_address_from'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address_from']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'users_in_charge') {
        this.ordersInfo['users_in_charge'] = value.user_name
        $this.$refs[ref].innerText = this.ordersInfo['users_in_charge']
        this.ordersInfo[field] = value.id
        val = value
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.ordersInfo[field] = val
      this.changeInfoTemp = this.changeInfoTemp + 1
      window.$('#popover-' + ref).popoverX('hide')
    },

    closeModal (ref) {
      if (ref) window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.ordersDetails.splice(i, 1)
    },

    updateOrders (updateType, user) {
      if (!this.ordersInfo.ordered_at) {
        this.$toastr.warning(this.translations('order.notice_order_date'))
        return
      }

      if (!this.ordersInfo.order_number) {
        this.$toastr.warning(this.translations('order.notice_order_number'))
        return
      }

      if (this.ordersInfo.division_type === 'B') {
        if (!this.ordersInfo.warehouse_id) {
          this.$toastr.warning(this.translations('order.notice_delivery_source'))
          return
        }
        if (!this.ordersInfo.warehouse_id_from) {
          this.$toastr.warning(this.translations('order.notice_delivery_source'))
          return
        }
        if (this.ordersInfo.warehouse_id_from === this.ordersInfo.warehouse_id) {
          this.$toastr.warning(this.translations('order.notice_same_delivery_destination'))
          return
        }
      } else {
        if (!this.ordersInfo.client_id) {
          this.$toastr.warning(this.translations('order.notice_shipping_address'))
          return
        }
      }

      if (this.ordersDetails.length === 0 && ((Number(this.statusId) !== OrderStatus.BACKORDER_MANAGE) ||
          (Number(this.statusId) === OrderStatus.BACKORDER_MANAGE && Number(this.ordersInfo.order_status) === OrderStatus.NOT_SHIPPED))) {
        this.$toastr.warning(this.translations('order.notice_enter_details_line'))
        return
      }
      let confirmMessage = ''
      let successMessage = ''
      let errorMessage = ''
      if (!updateType || updateType === UPDATE_TYPE_NORMAL) {
        confirmMessage = this.translations('order.update_order')
        successMessage = this.translations('order.notice_update_order_success')
        errorMessage = this.translations('order.notice_update_order_fail')
      } else if (updateType === UPDATE_TYPE_INFORMATION) {
        confirmMessage = this.translations('order.notice_update_order_information')
        successMessage = this.translations('order.notice_update_order_information_success')
        errorMessage = this.translations('order.notice_update_order_information_fail')
      } else if (updateType === UPDATE_TYPE_REQUEST_APPROVE) {
        confirmMessage = this.translations('order.notice_request_approval')
        successMessage = this.translations('order.notice_request_approval_success')
        errorMessage = this.translations('order.notice_request_approval_fail')
      } else if (updateType === UPDATE_TYPE_APPROVE) {
        confirmMessage = this.translations('order.notice_over_credit_limit')
        successMessage = this.translations('order.notice_over_credit_limit_approved')
        errorMessage = this.translations('order.notice_over_credit_limit_fail')
      }

      this.$dialog.confirm(confirmMessage, {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        try {
          this.isLoading = true

          const ordersInfo = JSON.parse(JSON.stringify(this.ordersInfo))

          if (this.poFile != null) {
            ordersInfo.purchase_order_file = this.poFile
          } else {
            ordersInfo.purchase_order_file = ''
          }

          if (updateType === UPDATE_TYPE_REQUEST_APPROVE) {
            ordersInfo.approval_status = 1 // 承認依頼中
          } else if (updateType === UPDATE_TYPE_APPROVE && user) {
            const approvers = JSON.parse(ordersInfo.approvers)
            if (approvers.indexOf(user.id) < 0) {
              approvers.push(user.id)
            }
            let allOk = true
            for (let i = 0; i < this.approveUsers.length; i++) {
              const needUser = this.approveUsers[i]
              if (approvers.indexOf(needUser.id) < 0) {
                allOk = false
              }
            }
            if (allOk) {
              ordersInfo.approval_status = 2 // 承認済
            }
            ordersInfo.approvers = JSON.stringify(approvers)
          }

          ordersInfo.is_send_temp = this.isTempShipping
          if (!this.isTempShipping) {
            ordersInfo.company_name_temp = ''
            ordersInfo.suppliers_temp = ''
            ordersInfo.remove_price_temp = false
            ordersInfo.destination_name_temp = ''
            ordersInfo.note_temp = ''
          }

          ordersInfo.slip_number = this.slipNumber
          ordersInfo.cd_item = this.cdItem
          if (ordersInfo.division_type === 'B') {
            ordersInfo.destination_name = ordersInfo.warehouse_address
          }
          let paramUpdate = {
            orders_id: this.ordersID,
            information: ordersInfo,
            details: this.ordersDetails,
            status_id: this.statusId
          }
          let updateOrder = await this.$http.post(this.$api_url.orders_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateOrder.data)
          console.log('SingleOrders:updateOrders: ', $data)
          if ($data.success === true) {
            this.$toastr.success(successMessage, this.translations('common.success'))
            this.ordersInfo = JSON.parse(JSON.stringify(ordersInfo))
            setTimeout(() => {
              location.reload()
            }, '500')
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          this.isLoading = false
          this.allChecked = false
        } catch (error) {
          this.isLoading = false
          this.allChecked = false
          console.log('SingleOrders:updateOrders:catch(error): ', error)
          this.$toastr.error(errorMessage + this.translations('order.notice_check_error'), this.translations('common.error'))
        }
      })
    },

    deleteOrders () {
      if (this.tempInfo.check_order_reserve) {
        this.$toastr.warning(this.translations('order.notice_delete_order'))
        return
      }
      this.$dialog.confirm(this.translations('order.delete_order'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      })
        .then(async () => {
          this.isLoading = true
          try {
            const response = await this.$http.post(this.$api_url.orders_delete, { orders_id: this.ordersID })
            const result = response.data
            if (result.status === true) {
              this.$toastr.success(this.translations('order.notice_deleted_order'), this.translations('common.success'))
              this.$router.replace('archive-orders')
              setTimeout(() => { this.isLoading = false }, 1000)
            } else {
              this.$toastr.warning(result.message)
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleOrders:deleOrders:catch(error): ', error)
            this.$toastr.error(this.translations('order.notice_deleted_order_fail'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    async addToShipping () {
      this.$dialog.confirm(this.translations('order.notice_continue_shipment'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      })
        .then(async () => {
          try {
            let shippedAt = this.$invoiceTools.getCurrentDate()

            let params = {
              orders_id: this.ordersID,
              shipping_at: shippedAt
            }
            let updateOrder = await this.$http.post(this.$api_url.add_to_shipped, params)
            let $data = this.$invoiceTools.prepareResult(updateOrder.data, '', 'SingleOrders:addToShipping')
            if ($data.success === true) {
              this.ordersInfo.order_status = 2
              this.$toastr.success(this.translations('order.notice_continue_shipment_success'), this.translations('common.success'))
            } else {
              this.$toastr.error($data.data, this.translations('common.error'))
            }
          } catch (error) {
            console.log('SingleOrders:addToShipping:catch(error): ', error)
            this.$toastr.error(this.translations('order.notice_continue_shipment_fail'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    requestApprove () {
      this.updateOrders(UPDATE_TYPE_REQUEST_APPROVE)
    },

    approve (user) {
      this.updateOrders(UPDATE_TYPE_APPROVE, user)
    },

    isUserApproved (user) {
      console.log(user)
      const approvers = JSON.parse(this.ordersInfo.approvers)
      console.log(approvers)
      return approvers.indexOf(user.id) >= 0
    },

    isApproveRole (user) {
      return user.id === this.$store.getters['User/id']
    },

    onChangeUnitPrice (detail) {
      if (Number(detail.tax_status) === 1) {
        if (Number(detail.taxclass_id) === 1) {
          detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, Number(detail.tax_rate || this.taxRate))
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
      } else {
        if (Number(detail.taxclass_id) === 1) {
          detail.unit_price = this.$util.getExcludeTax(detail.unit_price_inctax, Number(detail.tax_rate || this.taxRate))
        } else {
          detail.unit_price = detail.unit_price_inctax
        }
      }
    },

    moveOn () {
      if (this.afterId) {
        // $router.pushだとcreatedが走らないため
        location.href = `/single-orders?orders_id=${this.afterId}`
      }
    },

    returnOn () {
      if (this.beforeId) {
        // $router.pushだとcreatedが走らないため
        location.href = `/single-orders?orders_id=${this.beforeId}`
      }
    },

    getStatusClass (status, divisionType) {
      if (Number(status) === OrderStatus.NOT_SHIPPED && divisionType === DivisionType[2].value) {
        return 'badge-info'
      } else if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return 'badge-light'
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return 'badge-success'
      } else if (Number(status) === OrderStatus.MOVED) {
        return 'badge-danger'
      } else if (Number(status) === OrderStatus.MOVE_RESERVED) {
        return 'badge-info'
      }
      return 'badge-warning'
    },

    getStatusLabel (status, divisionType) {
      if (Number(status) === OrderStatus.NOT_SHIPPED && divisionType === DivisionType[2].value) {
        return this.translations('order.moving')
      } else if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return this.translations('order.not_ship')
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return this.translations('order.shipped')
      } else if (Number(status) === OrderStatus.MOVED) {
        return this.translations('order.move_completed')
      } else if (Number(status) === OrderStatus.MOVE_RESERVED) {
        return this.translations('order.reserved')
      }
      return this.translations('order.partial_shipment')
    },

    async getEmployeeByCompany () {
      this.isLoading = true
      try {
        const { data: { data, status } } = await this.$http.post(this.$api_url.employee_by_company, { company_id: this.tempInfo.client_id })
        if (status) {
          this.$set(this.tempInfo, 'end_user', data)
          this.updateField('end_user', data, 'info06')
        }
      } catch (error) {}
      this.isLoading = false
    },

    changeTempShipping () {
      if (this.isTempShipping) {
        this.tempInfo.company_name_temp = this.tempInfo.company_name_temp || this.tempInfo.client_name
        this.tempInfo.suppliers_temp = this.tempInfo.suppliers_temp || UNIQ_ADDRESS
        this.tempInfo.destination_name_temp = this.tempInfo.destination_name_temp || this.tempInfo.destination_name
        this.tempInfo.note_temp = this.tempInfo.note_temp || this.tempInfo.memo
        this.tempInfo.remove_price_temp = Boolean(Number(this.tempInfo.remove_price_temp)) || false
      }
    },

    updateSelectedType (event, index) {
      const newSelectedType = Number(event.target.value)
      if (newSelectedType === 0) {
        this.ordersDetails[index].is_bad = 0
        this.ordersDetails[index].is_outlet = 0
      } else if (newSelectedType === 1) {
        this.ordersDetails[index].is_bad = 1
        this.ordersDetails[index].is_outlet = 0
      } else if (newSelectedType === 2) {
        this.ordersDetails[index].is_bad = 0
        this.ordersDetails[index].is_outlet = 1
      }
    },

    calculateRows (text) {
      return text ? text.split('\n').length : this.inputRows
    },

    moveToReserve () {
      let confirmMessage = this.translations('order.update_order')
      let successMessage = this.translations('order.notice_update_order_success')
      let errorMessage = this.translations('order.notice_update_order_fail')
      let indexCheck = []
      this.ordersDetails.findIndex(ordersDetail => {
        if (ordersDetail.check) {
          indexCheck.push(ordersDetail)
        }
      })

      if (indexCheck.length < 1) {
        return this.$toastr.warning(this.translations('order.notice_select_one_product'))
      }
      this.$dialog.confirm(confirmMessage).then(async () => {
        try {
          this.isLoading = true
          let paramUpdate = {
            orders_id: this.ordersID,
            orders_detail: this.ordersDetails,
            reserve: false,
            all_check: this.allChecked
          }
          let $data = await this.$http.post(this.$api_url.order_move_reserve, paramUpdate)
          if ($data.data.status === true) {
            this.$toastr.success(successMessage, this.translations('common.success'))
            if (this.ordersDetails.length === indexCheck.length) {
              this.$router.replace('archive-orders')
            }
            setTimeout(() => {
              location.reload()
            }, '500')
          } else {
            this.$toastr.error($data.data.message, this.translations('common.error'))
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.$toastr.error(errorMessage + this.translations('order.notice_check_error'), this.translations('common.error'))
        }
      })
    },

    onChangeCheckedAll (e) {
      let ordersDetails = [...this.ordersDetails]
      let indexDetail = _.findIndex(this.ordersDetails, orderDetail =>
        Number(orderDetail.reserved) === 0 && orderDetail.check === false
      )
      let setChildCheckBox = true
      if (indexDetail === -1) {
        setChildCheckBox = false
      }
      ordersDetails = ordersDetails.map(function (orderDetail) {
        if (Number(orderDetail.reserved) === 0) {
          orderDetail.check = setChildCheckBox
        } else {
          orderDetail.check = false
        }
        return orderDetail
      })
      this.ordersDetails = ordersDetails
      this.allChecked = e.target.checked
    },

    onChangeInputChecked (e) {
      let id = parseInt(e.target.value)
      let indexDetail = _.findIndex(this.ordersDetails, function (orderDetail) { return orderDetail.id === id })
      let ordersDetails = [...this.ordersDetails]
      ordersDetails[indexDetail].check = !ordersDetails[indexDetail].check
      this.ordersDetails = ordersDetails
      let checkAllInputChecked = _.every(ordersDetails, function (orderDetail) {
        return Number(orderDetail.reserved) !== 0 || orderDetail.check === true
      })
      this.allChecked = checkAllInputChecked
    }
  }
}
</script>

<style>
[for='checkBox'] {
  margin-top: 7px;
  margin-right: 0.6rem;
}
</style>

<style scoped>
.btn-memo-internal {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.min-height-120 {
  min-height: 120px;
}
textarea {
  resize: both;
}
</style>
